import { Action } from '@ngrx/store';

export enum EntryCycleIdAction {
  Init = '[EntryCycleId] Init',
  Set = '[EntryCycleId] Set',
  Reset = '[EntryCycleId] Reset',
}

/**
 * Initialize the entry cycle ID from localStorage
 * Should only be used by the reducer, not by the effect
 */
export class Init implements Action {
  readonly type = EntryCycleIdAction.Init;

  constructor(public entryCycleId: number) {}
}

export class Set implements Action {
  readonly type = EntryCycleIdAction.Set;

  constructor(public entryCycleId: number) {}
}

export class Reset implements Action {
  readonly type = EntryCycleIdAction.Reset;
}

export type EntryCycleIdActionType = Init | Set | Reset;
